// Ported from sn-plugin2 packages/embed-contract/src/{config,themeOptions,displayOptions}.ts @ 54685d64 — keep in step with the plugin.
import {
  PLUGIN_FONT_SIZE_RANGE,
  PLUGIN_FOOTER_LINK_MAX,
  PLUGIN_FOOTER_TEXT_MAX,
  PLUGIN_LETTER_SPACING_RANGE,
  PLUGIN_SPACING_UNIT_RANGE,
} from './embedOptions'

export const PLUGIN_ENTITY_ID_PATTERN = /^[A-Za-z0-9_-]+$/
export const PLUGIN_ENTITY_ID_MAX = 64
export const PLUGIN_HEX_COLOUR_PATTERN = /^#[0-9a-fA-F]{6}$/
export const PLUGIN_FONT_NAME_PATTERN = /^[A-Za-z][A-Za-z0-9 ]{0,49}$/

/**
 * Characters that break the line or could disguise the text: control
 * characters, line/paragraph separators, the zero-width space, the BOM and
 * the bidi marks, embeddings, overrides and isolates.
 */
export const PLUGIN_CONTROL_CHARACTERS =
  /[\p{Cc}\p{Zl}\p{Zp}\u200B\uFEFF\u200E\u200F\u061C\u202A-\u202E\u2066-\u2069]/u

export const PLUGIN_VALIDATION_MESSAGES = {
  required: 'Required',
  entityId: `Use letters, numbers, - and _ (up to ${PLUGIN_ENTITY_ID_MAX} characters)`,
  fontName: 'Must be a font name like Open Sans',
  hexColour: 'Must be a 6-digit hex colour like #F2B400',
  fontSize: `Must be a whole number from ${PLUGIN_FONT_SIZE_RANGE.min} to ${PLUGIN_FONT_SIZE_RANGE.max}`,
  letterSpacing: `Must be from ${PLUGIN_LETTER_SPACING_RANGE.min} to ${PLUGIN_LETTER_SPACING_RANGE.max} in steps of ${PLUGIN_LETTER_SPACING_RANGE.step}`,
  spacing: `Must be from ${PLUGIN_SPACING_UNIT_RANGE.min} to ${PLUGIN_SPACING_UNIT_RANGE.max} in steps of ${PLUGIN_SPACING_UNIT_RANGE.step}`,
  positiveWhole: 'Must be a whole number above 0',
  footerTextRequired: 'Must have text',
  footerTextMax: `Must be at most ${PLUGIN_FOOTER_TEXT_MAX} characters`,
  footerTextPlain: 'Must be one line of plain text',
  footerLinkMax: `Must be at most ${PLUGIN_FOOTER_LINK_MAX} characters`,
  footerLink: 'Must be an https link like https://example.com',
} as const
